export default __webpack_public_path__ + "static/media/documents.3ec439f8.svg";